@if (category$ | async; as category) {
    <div class="container">
        <div class="row no-gutters">
            <div class="col-12" [ngClass]="{ 'col-lg-6': category.image?.url }">
                <div id="category-content-anchor" class="category-content"
                     [ngClass]="{ 'category-content-half-width': category.image?.url }">
                    @let isMobileApp = isMobileApp$|async;
                    @if (!isMobileApp && breadCrumbs$ | async; as breadcrumbs) {
                        <aimo-breadcrumb [hideTitle]="true"
                                         [addFrontPageLink]="false"
                                         [showBackLink]="false"
                                         [breadCrumbs]="breadcrumbs">
                        </aimo-breadcrumb>
                    }
                    <div class="category-description">
                        <h1>{{ category.name }}</h1>
                        @if (category.description) {
                            <div [innerHTML]="category.description">{{ category.description }}</div>
                        }
                    </div>

                    @if (category.level < 2 && !category.dummyCategory) {
                        @if (categoryHierarchy$ | async; as hierarchy) {
                            <div class="sub-categories-wrapper">
                                <div class="sub-categories">
                                    <aimo-category-header-subcategory
                                        [categoryId]="hierarchy.id"
                                        [showAll]="showAllCategories"
                                        (showAllAction)="toggleShowAllCategories($event)"
                                        [values]="hierarchy.subcategories">
                                    </aimo-category-header-subcategory>
                                </div>
                            </div>
                        }
                    }
                    @if (category.level > 1 || category.dummyCategory) {
                        @if (facets$ | async; as facet) {
                            @if (isShowSubCategories(category.level, facet) || category.dummyCategory) {
                                <div class="sub-categories-wrapper">
                                    <div class="sub-categories">
                                        @if (selectedCategoryId$ | async; as selectedCategoryId) {
                                            @if (!category.dummyCategory) {
                                                <a
                                                    [routerLink]="'/category/' + selectedCategoryId"
                                                    [queryParams]="{query:createSelectAllQuery(category), parentCategory: category.code}"
                                                    class="btn-facet btn-sm category"
                                                    [ngClass]="{ selected: isAllCategoriesSelected(facet) }">
                                                    {{
                                                        ('aimo.product.allCategories' | cxTranslate) +
                                                        ' ' +
                                                        category.name.toLowerCase()
                                                    }}
                                                    @if (total$ | async; as total) {
                                                        <span class="amount">{{ total }}</span>
                                                    }
                                                </a>
                                            }

                                            <aimo-product-category-facets
                                                [parentCategoryId]="category.code"
                                                [showAll]="showAllCategories"
                                                (showAllAction)="toggleShowAllCategories($event)"
                                                [values]="facet.values"
                                                [lowestLevelSelected]="!category.dummyCategory"
                                                [link]="'/category/' + selectedCategoryId"></aimo-product-category-facets>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    }
                </div>
            </div>
            @if (category.image?.url) {
                <div class="col-12 col-lg-6">
                    <div class="category-image">
                        <cx-media [loading]="'lazy'" [container]="category.image" class="d-none d-lg-block"></cx-media>
                    </div>
                </div>
            }
        </div>
    </div>
}
